import { GoogleLoginResponse } from 'react-google-login';

import {
  LoginGoogleInput,
  LoginInput,
  LoginLocalInput,
  LoginPassword,
  LoginRequest
} from 'models/auth';
import { httpClient } from 'services/httpClient';

export const AUTH_TOKEN_KEY = 'AUTH_TOKEN_KEY';
export const ADMIN_LOGIN_PATH = '/admin/auth/login';

class AuthService {
  public async login(variables: LoginRequest): Promise<{ token: string }> {
    const response = await httpClient.post(ADMIN_LOGIN_PATH, variables);
    const token: string | undefined = response.data?.data?.token;

    if (!token) {
      throw new Error('Invalid login response');
    }

    return { token };
  }

  public buildVariables(input: LoginInput): LoginRequest {
    const { loginType } = input;

    let variables = {
      loginType
    } as LoginRequest;

    if (loginType === 'PASSWORD' && input.local) {
      const localInfo = this.getLoginLocalVariables(input.local);

      if (localInfo) {
        variables = {
          ...variables,
          ...localInfo
        };
      }
    }

    if (loginType === 'GOOGLE' && input.google) {
      const googleInfo = this.getLoginGoogleVariables(input.google);

      if (googleInfo) {
        variables = {
          ...variables,
          ...googleInfo
        };
      }
    }

    return variables;
  }

  private getLoginLocalVariables(local: LoginPassword): LoginLocalInput | null {
    if (!local || !local.email || !local.password) {
      return null;
    }

    return {
      email: local.email,
      password: local.password
    };
  }

  private getLoginGoogleVariables(
    input: GoogleLoginResponse
  ): LoginGoogleInput | null {
    if (!input || !input?.profileObj?.email || !input?.accessToken) {
      return null;
    }

    return {
      email: input.profileObj.email,
      accessToken: input.accessToken
    };
  }
}

const singleton = new AuthService();

export { singleton as AuthService };
